import { Button } from "antd";
import { useState } from "react";
import { isEmpty } from "lodash";
import Column from "../../components/Column";
import AppInputText from "../../components/AppInputText/AppInputText";
import { UserOutlined } from "@ant-design/icons";
import "./Register.scss";
import { isValidVietnamPhone } from "../../../applications/useCase/BusinessUseCase/LoginUseCase";
import usePageState from "../../hooks/usePageState";
import { adminRegisterUseCase } from "../../../applications/useCase/ApiUseCase/AuthenticationApiUseCase";

interface Props {
  setOpenRegisterForm?: (val: boolean) => void;
  isAdministrator?: boolean;
}

function RegisterForm(props: Props) {
  const { setOpenRegisterForm, isAdministrator = false } = props;
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [fullName, setFullName] = useState<string>("");

  const { setLoading, showClientError, showError, showSuccess } = usePageState();

  async function handleRegister() {
    if (isEmpty(username) || isEmpty(password) || isEmpty(fullName)) {
      showClientError("Vui lòng nhập đầy đủ thông tin đăng ký");
      return;
    }
    if (password?.length < 8) {
      showClientError("Mật khẩu phải có độ dài lớn hơn 8 kí tự");
      return;
    }
    const isValid = isValidVietnamPhone(username);

    if (!isValid) {
      showClientError("Số điện thoại không hợp lệ");
      return;
    }
    const res = await adminRegisterUseCase({
      userName: username,
      password: password,
      fullName: fullName,
      isAdministrator: isAdministrator,
      setLoading,
      showError,
      showSuccess,
    });
    if (res) {
      setOpenRegisterForm?.(false);
    }
  }

  return (
    <Column className={`gap-4 register-form`}>
      <AppInputText
        orientation="col"
        isRequired
        label="Họ và Tên"
        currentValue={fullName}
        onTextChange={(value) => {
          setFullName(value);
        }}
        additionProps={{
          className: "w-100 form-item",
          autoFocus: true,
        }}
      />
      <AppInputText
        orientation="col"
        isRequired
        label="Số điện thoại"
        currentValue={username}
        onTextChange={(value) => {
          setUsername(value);
        }}
        additionProps={{
          className: "w-100 form-item",
        }}
      />

      <AppInputText
        orientation="col"
        isRequired
        label="Mật khẩu"
        currentValue={password}
        onTextChange={(value) => {
          setPassword(value);
        }}
        additionProps={{
          className: "w-100 form-item",
          onCut: (e: React.ClipboardEvent<HTMLInputElement>) => {
            e.preventDefault();
          },
          onCopy: (e: React.ClipboardEvent<HTMLInputElement>) => {
            e.preventDefault();
          },
        }}
        textType={"PASSWORD"}
      />

      <Button
        onClick={handleRegister}
        icon={<UserOutlined />}
        type="primary"
        style={{
          height: 36,
          marginTop: "1.5rem",
        }}
      >
        Đăng ký
      </Button>
    </Column>
  );
}
export default RegisterForm;
